import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { NeverShowRouteResolver } from '../shared/navigation/never-show-route-resolver';
import { PermissionLevel } from '../shared/permission/permission';
import { CirrusShowcaseComponent } from './cirrus/cirrus-showcase.component';
import { ComponentsShowcaseComponent } from './components-showcase.component';

export const componentShowcaseRoutes: Array<DynamicRoute> = [
  {
    path: 'components',
    component: ComponentsShowcaseComponent,
    data: {
      show: NeverShowRouteResolver,
      title: 'Components Showcase',
      icon: 'icon-dashboard.svg',
      permissionLevel: PermissionLevel.MANAGER,
      type: []
    }
  },
  {
    path: 'cirrus',
    component: CirrusShowcaseComponent,
    data: {
      show: NeverShowRouteResolver,
      title: 'Cirrus Showcase',
      icon: 'icon-dashboard.svg',
      permissionLevel: PermissionLevel.MANAGER,
      type: []
    }
  }
];
